import { z } from 'zod';
export const EdgeSecretsSchema = z.object({
    // Supabase built-in secrets (automatically available)
    SUPABASE_URL: z.string().url(),
    SUPABASE_ANON_KEY: z.string().min(1),
    SUPABASE_SERVICE_ROLE_KEY: z.string().min(1),
    SUPABASE_DB_URL: z.string().url().optional(),
    // Monitoring and error tracking
    SENTRY_DSN: z.string().url().optional(),
    SENTRY_ENVIRONMENT: z
        .enum(['local', 'staging', 'production'])
        .default('local'),
    SENTRY_DEBUG: z
        .string()
        .transform((val) => val === 'true')
        .default('false'),
    SENTRY_TRACES_SAMPLE_RATE: z
        .string()
        .transform((val) => Number(val))
        .pipe(z.number().min(0).max(1))
        .default('0.1'),
    // Custom application secrets (optional, added as needed)
    STRIPE_SECRET_KEY: z.string().optional(),
    STRIPE_WEBHOOK_SECRET: z.string().optional(),
    // Stripe price IDs per paid tier. FREE has no price.
    STRIPE_PRICE_ID_CORE: z.string().optional(),
    STRIPE_PRICE_ID_FAMILY: z.string().optional(),
    // Deprecated: kept for backward compat with single-tier deployments.
    // Maps to STRIPE_PRICE_ID_CORE when present.
    STRIPE_PRICE_ID: z.string().optional(),
    SENDGRID_API_KEY: z.string().optional(),
    WEBHOOK_SECRET: z.string().optional(),
    JWT_SECRET: z.string().optional(),
    // Twilio SMS + daily digest (all optional — unset = graceful skip / no SMS).
    TWILIO_ACCOUNT_SID: z.string().optional(),
    TWILIO_AUTH_TOKEN: z.string().optional(),
    TWILIO_MESSAGING_SERVICE_SID: z.string().optional(),
    TWILIO_VERIFY_SERVICE_SID: z.string().optional(),
    // Optional overrides for webhook signature canonical URLs.
    TWILIO_STATUS_CALLBACK_URL: z.string().optional(),
    TWILIO_INBOUND_URL: z.string().optional(),
    // Absolute web base URL used to build tappable links in SMS bodies.
    WEB_APP_BASE_URL: z.string().optional(),
    // Server-side kill-switch ('false' halts all sends) + per-user/day SMS cap.
    SMS_ENABLED: z.string().optional(),
    SMS_DAILY_CAP_PER_USER: z.string().optional(),
});
export const RequiredEdgeSecretsSchema = z.object({
    SUPABASE_URL: z.string().url(),
    SUPABASE_ANON_KEY: z.string().min(1),
    SUPABASE_SERVICE_ROLE_KEY: z.string().min(1),
});
